import React, {Component} from 'react';
import {translate} from 'react-i18next';
import Popover from 'react-awesome-popover';
import config from '../../../config/config.js';
import axios from 'axios';
import Select2 from 'react-select2-wrapper';

class EditRoute extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            availableWaitingSpots: [],
            name: '',
            waitingSpot: null,
            errors: []
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.loadRoute = this.loadRoute.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleOpen = this.handleOpen.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }

    handleInputChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleOpen() {
        this.setState({
            open: true,
            availableWaitingSpots: [],
            name: '',
            waitingSpot: null,
            errors: []
        });
        this.loadRoute();
    }

    handleClose() {
        this.setState({
            availableWaitingSpots: [],
            name: '',
            waitingSpot: null,
            open: false,
            errors: []
        });
        this.props.handleClose();
    }

    loadRoute() {
        let that = this;
        axios(config.server.endpoint + 'backend/route/' + that.props.id, {
            method: 'get'
        }).then((response) => {
            if (response.status === 200) {
                that.setState({
                    availableWaitingSpots: response.data.availableWaitingSpots,
                    id: response.data.id,
                    name: response.data.name,
                    waitingSpot: response.data.waitingSpot,
                    errors: []
                });
            }
        });
    }

    handleSave() {
        let that = this;
        axios(config.server.endpoint + 'backend/route/' + that.props.id, {
            method: 'put',
            data: {
                name: that.state.name,
                waitingSpot: that.state.waitingSpot
            }
        }).then((response) => {
            if (response.status === 200) {
                if(response.data.success === true) {
                    that.handleClose();
                } else {
                    this.setState({
                        errors: response.data.errors
                    });
                }
            }
        });
    }

    render() {
        const { t } = this.props;
        return (
            <Popover targetClass="m-l-xs" onOpen={this.handleOpen} onClose={this.handleClose} open={this.state.open} contentClass="rap-popover-content">
                <a>
                    <i className="fa fa-pencil"/>
                </a>
                <div className="p-md" style={{width: 400, textAlign: 'left'}}>
                    <div
                        className="form-group">
                        <label>{t('route.name.label')}</label>
                        <input type="text" name="name" value={this.state.name} onChange={this.handleInputChange} className="form-control"/>
                        {(this.state.errors && this.state.errors.name) ? (
                            <span className="help-block">
                                {t('route.name.error.' + this.state.errors.name)}
                            </span>
                        ) : null}
                    </div>
                    <div
                        className="form-group">
                        <label>{t('route.waitingSpot.label')}</label>
                        <Select2 data={this.state.availableWaitingSpots.map((el) => {
                            return {
                                text: el.name, id: el.id
                            }
                        })} value={this.state.waitingSpot} onChange={this.handleInputChange} name="waitingSpot"
                                 options={{placeholder: t('route.waitingSpot.placeholder'), allowClear: true}}
                                 className="width-100p block"/>
                    </div>
                    <button className="btn btn-small btn-primary" onClick={this.handleSave}>
                        <i className="fa fa-save m-r-sm"/>
                        {t('default.save')}
                    </button>
                </div>
            </Popover>
        )
    }
}

export default translate()(EditRoute);